import React, { useState,useEffect } from 'react';

import { useTranslation } from 'react-i18next';


const NoResult = ({ AuthService, UserService,selection }) => {


  const { t } = useTranslation();

  return (
    
<div class="no-content-search">


 <svg
    id="Livello_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 283.46 283.46"
    style={{
      enableBackground: "new 0 0 283.46 283.46",
    }}
    xmlSpace="preserve"

  >
    <g>
      <path d="M169.4,164.42c-3.1,0.48-6.29,0.73-9.46,0.73c-33.64,0-61.01-27.37-61.01-61.01s27.37-61.01,61.01-61.01          s61.01,27.37,61.01,61.01c0,2.5-0.15,5.01-0.45,7.48c-0.52,4.23,2.5,8.08,6.73,8.6c4.26,0.52,8.08-2.5,8.6-6.73          c0.38-3.08,0.57-6.23,0.57-9.35c0-42.16-34.3-76.45-76.45-76.45s-76.45,34.3-76.45,76.45s34.3,76.45,76.45,76.45          c3.97,0,7.95-0.31,11.84-0.91c4.21-0.65,7.1-4.6,6.44-8.82C177.57,166.65,173.63,163.75,169.4,164.42z" />
      <path d="M232.46,134.03c-22.27,0-40.38,18.11-40.38,40.38s18.12,40.38,40.38,40.38s40.38-18.12,40.38-40.38          S254.73,134.03,232.46,134.03z M232.46,208.62c-18.86,0-34.21-15.34-34.21-34.21c0-18.86,15.34-34.2,34.21-34.2          s34.21,15.34,34.21,34.2C266.67,193.27,251.32,208.62,232.46,208.62z" />
      <path d="M102.66,161.69c-3.62-3.62-9.49-3.62-13.1,0l-13.13,13.13c-4.8-0.75-9.87,0.71-13.56,4.41l-46.62,46.62          c-6.15,6.15-6.15,16.11,0,22.26c3.07,3.07,7.1,4.61,11.13,4.61s8.06-1.54,11.13-4.61l46.62-46.62c3.69-3.69,5.15-8.77,4.41-13.56          l13.13-13.13C106.28,171.17,106.28,165.3,102.66,161.69z" />
      <path
        className="icon-x"
        d="M249.97,156.9c-2.41-2.41-6.32-2.41-8.73,0l-8.78,8.78l-8.78-8.78c-2.41-2.41-6.32-2.41-8.73,0          c-2.41,2.41-2.41,6.32,0,8.73l8.78,8.78l-8.78,8.78c-2.41,2.41-2.41,6.32,0,8.73c1.2,1.21,2.79,1.81,4.37,1.81s3.16-0.6,4.37-1.81          l8.78-8.78l8.78,8.78c1.21,1.21,2.79,1.81,4.37,1.81s3.16-0.6,4.37-1.81c2.41-2.41,2.41-6.32,0-8.73l-8.78-8.78l8.78-8.78          C252.39,163.22,252.39,159.31,249.97,156.9z"
      />
    </g>
  </svg>

    <h3>{t('There_are_no_results')}<br/><small>{t('No_results_found_for_your_request')}</small></h3>
</div>

  );
};


export default NoResult;







